// Layout: People
// Auto-scroll to People section on deep-link
document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('[data-auto-open-person="true"]');
    if (section) {
        requestAnimationFrame(function () {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }
});
